import styled from 'styled-components';

import { donedealBreakpoints } from 'styled-system';

const { media } = donedealBreakpoints;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ProviderLogo = styled.img<{ $responsive?: boolean }>`
  margin-bottom: ${({ theme }) => theme.spacing.S8};
  height: ${({ $responsive }) => ($responsive ? 'auto' : '76px')};
  max-height: ${({ $responsive }) => ($responsive ? '48px' : 'none')};
  max-width: ${({ $responsive }) => ($responsive ? '40%' : 'none')};

  ${media.medium} {
    max-height: ${({ $responsive }) => ($responsive ? '76px' : 'none')};
    max-width: none;
  }
`;

const Heading = styled.h1`
  ${({ theme }) => theme.fontSize.L18};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-bottom: ${({ theme }) => theme.spacing.S8};

  ${media.medium} {
    ${({ theme }) => theme.fontSize.L24};
  }
`;

const Copy = styled.p`
  ${({ theme }) => theme.fontSize.M16};
  margin-bottom: ${({ theme }) => theme.spacing.M16};
`;

export { Header, ProviderLogo, Heading, Copy };
